import React, { useEffect, useMemo, useState } from 'react';
import CategoriesMenu from './CategoriesMenu';
import {
    useZitoneoComplementaryData,
    useZitoneoHotelServices,
} from '../../../contextsProperty/ContextProperties';
import ServiceListDetail from './ServiceListDetail';
import { ZinantisHotelServiceFilterOption } from '../../../../types/properties/propertyTypes';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';
import LoadingZitoneoServices from './LoadingZitoneoServices';

const ZitoneoServices = () => {
    const { setErrorMessage } = useNotification();
    const { serviceCategoriesList, serviceTypesList, getZitoneoServicesData } =
        useZitoneoComplementaryData();
    const {
        zitoneoServices,
        toggleZitoneoService,
        addNewZitoneoService,
        visibleIdServicesDetail,
        handleToggleVisibleServicesDetail,
        handleChangeZitoneoServiceValue,
        handleRemoveZitoneoServiceValue,
    } = useZitoneoHotelServices();
    const [isFetching, setIsFetching] = useState(false);
    const [idSelectedCategory, setIdSelectedCategory] = useState(0);
    const [activeButton, setActiveButton] =
        useState<ZinantisHotelServiceFilterOption>(
            ZinantisHotelServiceFilterOption.ALL
        );

    const handleActiveButtonChange = (
        option: ZinantisHotelServiceFilterOption
    ) => {
        setActiveButton(option);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                setIsFetching(true);
                await getZitoneoServicesData();
            } catch (error) {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            } finally {
                setIsFetching(false);
            }
        };
        getData();
    }, []);

    const handleSelectCategory = (idCategory: number) => {
        setIdSelectedCategory(idCategory);
        if (!idCategory) {
            setActiveButton(ZinantisHotelServiceFilterOption.SELECTED);
        }
    };

    const serviceTitle = useMemo(() => {
        if (idSelectedCategory === 0) {
            return 'your_hotel_services';
        }
        const selectedCategory = serviceCategoriesList.find(
            category => parseInt(category.id) === idSelectedCategory
        );
        return selectedCategory ? selectedCategory.name : '';
    }, [idSelectedCategory, serviceCategoriesList]);

    return (
        <main className='service__container'>
            {isFetching ? (
                <LoadingZitoneoServices />
            ) : (
                <>
                    <CategoriesMenu
                        categories={serviceCategoriesList}
                        idSelectedCategory={idSelectedCategory}
                        onSelectCategory={handleSelectCategory}
                    />
                    <ServiceListDetail
                        title={serviceTitle}
                        services={serviceTypesList}
                        selectedServices={zitoneoServices}
                        categories={serviceCategoriesList}
                        idSelectedCategory={idSelectedCategory}
                        onSelectCategory={handleSelectCategory}
                        onToggleService={toggleZitoneoService}
                        onAddZitoneoService={addNewZitoneoService}
                        activeButton={activeButton}
                        onActiveButtonChange={handleActiveButtonChange}
                        visibleIdServicesDetail={visibleIdServicesDetail}
                        onToggleVisibleServicesDetail={
                            handleToggleVisibleServicesDetail
                        }
                        onChangeZitoneoServiceValue={
                            handleChangeZitoneoServiceValue
                        }
                        onRemoveZitoneoServiceValue={
                            handleRemoveZitoneoServiceValue
                        }
                    />
                </>
            )}
        </main>
    );
};

export default ZitoneoServices;
